'use strict';

var template = require('employer/templates/employee/DefaultPayrollDetail.ejs');

var RowEditView = require('commons/views/RowEdit.js');

module.exports = RowEditView.extend({
    tagName:   'tr',
    className: 'tr-md payroll-detail',

    events: function() {
        var parentEvents = _.isFunction(RowEditView.prototype.events) ?
            RowEditView.prototype.events() : RowEditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'focus input': 'onFocus'
        });
    },

    initialize: function(options) {
        this.options = _.extend(options || {}, {
            template: template,
            deletable: true
        });

        return RowEditView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        var r = RowEditView.prototype.bindHandlers.apply(this, arguments);

        this.model.on('change:rate change:unit', this.renderAmount, this);
        this.model.on('change:additionalInformation', this.render, this);

        if (this.model.isZakat()) {
            this.model.on(
                'change:rate change:amount',
                this.toggleZakatMode,
                this
            );
        }

        return r;
    },

    onFocus: function(ev) {
        this.$(ev.currentTarget).select();
        return this;
    },

    renderAmount: function() {
        this.$('input[name=amount]').val(
            (this.model.get('amount') || 0).formatWithoutRounding()
        );
        return this;
    },

    renderRate: function() {
        this.$('input[name=rate]').val(
            (this.model.get('rate') || 0).formatWithoutRounding()
        );
        return this;
    },

    toggleZakatMode: function(model, value, options) {
        let changes = options.changes || {};
        if (value === 0) {
            return;
        }

        if (changes.amount) {
            this.model.set({rate: null}, {silent: true});
        } else if (changes.rate) {
            this.model.set({amount: null}, {silent: true});
        }
        this.renderAmount();
        this.renderRate();
    },

    destroyModel: function(ev) {
        ev.preventDefault();

        this.model.collection.remove(this.model);
        return this;
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/employee/DefaultPayrollDetail.js